export enum ButtonSize {
  s = 's',
  sm = 'sm',
  m = 'm',
  l = 'l',
  xl = 'xl',
}
